module.exports = __webpack_public_path__ + "58974790d0d3ecbe87af958281f5c75d.svg";